import { render, staticRenderFns } from "./Subtext.vue?vue&type=template&id=652afea8&"
import script from "./Subtext.vue?vue&type=script&lang=ts&"
export * from "./Subtext.vue?vue&type=script&lang=ts&"
import style0 from "./Subtext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports